module.exports = "/_next/static/images/Frame@2x-46efb844cd4aa9b4c08fcc793e47a567.png";